import { ApiClient } from "apis/config/apiClient";

const SPRING_BACKEND_URL = import.meta.env.VITE_SPRING_BACKEND_URL;

interface RefreshTokenResponse {
  data: {
    accessToken: string;
  };
}

export const refreshAccessToken = async (): Promise<string> => {
  try {
    // withCredentials: true로 쿠키 자동 전송 (audionRT 포함)
    const refreshResponse = await ApiClient.getInstance()
      .getAxiosInstance()
      .post<RefreshTokenResponse>(`${SPRING_BACKEND_URL}/auth/token/refresh`, {});
    console.log("refreshResponse", refreshResponse);
    return refreshResponse.data.data.accessToken;
  } catch (error) {
    console.error("Error refreshing access token:", error);
    alert("토큰 갱신 실패");
    throw error;
  }
};
